import LocationInfo from './LocationInfo';
import './LocationInfo.scss';

export default LocationInfo;
